export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6896.17908a38.jpg";